import { useEventListener } from "@vueuse/core";
import { getActivePinia } from "pinia";
import { useStore } from "../store";
import { LAYOUT_MOBILE_BREAKPOINT } from "./layoutBreakpoint";

function update() {
	if (!getActivePinia()) {
		return;
	}

	const { app } = useStore();
	const prevNarrow = app.browser.width < LAYOUT_MOBILE_BREAKPOINT;

	app.setBrowser();

	const nowNarrow = app.browser.width < LAYOUT_MOBILE_BREAKPOINT;

	// 窄屏：默认收起侧栏，避免盖住主内容（现场预览等全屏弹层）
	if (nowNarrow) {
		app.fold(true);
	} else if (prevNarrow && !nowNarrow) {
		// 从手机模拟/小窗恢复到桌面宽度：展开侧栏
		app.fold(false);
	}
}

export function resize() {
	useEventListener(window, "resize", update);
	update();
}
